import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const positions = new Map();

export default function ScrollManager() {
  const location = useLocation();
  const navType = useNavigationType();
  const key = location.key;

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    const onScroll = () => positions.set(key, window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [key]);

  useEffect(() => {
    if (navType === "POP") {
      const y = positions.get(key) ?? 0;
      requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, y)));
    } else {
      window.scrollTo(0, 0);
    }
  }, [key, navType]);

  return null;
}
